import React from "react";
import { Input } from "src/sudokit/components/Input";
import { Textarea } from "src/sudokit/components/Textarea";

interface FieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  optional?: boolean;
  multiline?: boolean;
  minRows?: number;
}

const Field: React.FC<FieldProps> = ({ id, label, value, onChange, placeholder, optional = false, multiline = false, minRows = 3 }) => (
  <div className="flex flex-col gap-2 w-full">
    <label htmlFor={id} className="text-sm font-medium">
      {label} {optional && <span className="text-app-grey-1 font-normal">(optional)</span>}
    </label>
    {multiline ? (
      <Textarea
        mode="default"
        id={id}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
        placeholder={placeholder}
        minRows={minRows}
      />
    ) : (
      <Input
        mode="default"
        id={id}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    )}
  </div>
);

export default Field;
